import { render, staticRenderFns } from "./ComponentProductDetails.vue?vue&type=template&id=74dae290&"
import script from "./ComponentProductDetails.vue?vue&type=script&lang=ts&"
export * from "./ComponentProductDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports